import { events } from '../../Constants';

export default class CartCounter {
  el: Element;

  $window: any;

  cartItems: Array<any>;

  count: number;

  constructor(el: Element, cartItems: Array<any>) {
    this.el = el;
    this.cartItems = cartItems;
    this.$window = $(window);
    this.setCount = this.setCount.bind(this);
    this.requestCompleted = this.requestCompleted.bind(this);
    this.init();
  }

  private init() {
    this.setCount(this.cartItems);
    this.$window.on(events.cartjs.requestComplete, this.requestCompleted);
  }

  private requestCompleted(event: any, data: any) {
    this.setCount(data.items);
  }

  private setCount(items: Array<any>) {
    let count = 0;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      let skipItem = false;
      // If product type is Planter, and it has a relationID,
      // skip it.  Doesn't need to be counted in the total cart count.
      // eslint-disable-next-line no-underscore-dangle
      if (global.__isLRPlanterProduct__(item.product_type)) {
        if (item.properties) {
          if (item.properties.relationID) {
            skipItem = true;
          }
        }
      }

      if (item.product_type === 'Carbon Offset') {
        skipItem = true;
      }

      if (!skipItem) {
        count += item.quantity;
      }
    }
    this.el.innerHTML = String(count);
    if (count <= 0) {
      $(this.el)
        .addClass('hide')
        .removeClass('show');
    } else {
      $(this.el)
        .addClass('show')
        .removeClass('hide');
    }
  }
}
